import React, { Component, Dispatch } from 'react';
import { IAppState, IAction } from '../../../models/action/core';
import { ILoginAnnouncementModalProp } from '../../../models/components/login-announcement-modal-props';
import { connect } from 'react-redux';
import { Common } from '../../../core/common';
import Moment from 'moment';
import Loading from '../../../components/loading/loading';
import { Log, Level, Logger } from 'ng2-logger';
import { SecureImage } from '../../../components/core/secureImage';
import { UserType } from '../../../models/enums/userType';
import Translator from '../../../core/i18n';
import ContentLoader from 'react-content-loader';
import Cookies from 'universal-cookie';

const _logger = Log.create('login.tsx');
const T = Translator.create();
let _common: Common;
class CMobileAnnouncementModal extends Component<ILoginAnnouncementModalProp> {
    constructor(props: any) {
        super(props);
        _common = new Common();

    }

    public clickToDownload = (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            _common.DownloadLink(filepath + '/download', fileName);
        }
    };

    public getUserType = (userTypeId: UserType) => {
        if (userTypeId === UserType.Student) {
            return T.t('r_gen_student');
        }
        if (userTypeId === UserType.User) {
            return T.t('r_gen_user');
        }
        if (userTypeId === UserType.Teacher) {
            return T.t('r_gen_teacher');
        }
        if (userTypeId === UserType.Parent) {
            return T.t('r_gen_parent');
        }
        if (userTypeId === UserType.Guest) {
            return T.t('r_gen_guest');
        }
    };

    public render() {
        return (
            <div className="announcement-detail-content" style={{ minHeight: 250 }}>
                <Loading spinnerId={'getLoginAnnouncementModal'} >
                    <ContentLoader
                        speed={1}
                        width={700}
                        height={150}
                        viewBox="0 0 700 150"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                    >
                        <circle cx="19" cy="25" r="18" />
                        <rect x="40" y="12" rx="5" ry="5" width="220" height="10" />
                        <rect x="40" y="29" rx="5" ry="5" width="220" height="10" />

                        <rect x="280" y="12" rx="5" ry="5" width="220" height="10" />
                        <rect x="280" y="29" rx="5" ry="5" width="220" height="10" />

                        <rect x="0" y="60" rx="0" ry="0" width="165" height="7" />
                        <rect x="0" y="80" rx="0" ry="0" width="680" height="10" />
                        <rect x="0" y="97" rx="0" ry="0" width="680" height="10" />
                        <rect x="0" y="114" rx="0" ry="0" width="680" height="10" />
                    </ContentLoader>
                </Loading>
                {
                    <div id="getLoginAnnouncementModal_Content">
                        <div className="announcement-stats border-bottom pb-3 mb-4 mt-2" />
                        <div className="announcement-content">
                            <img src={_common.GetMobileAppAnnouncement('mobileappone')} style={{ width: '-webkit-fill-available' }} alt="MobileAppAnnouncement1"></img>
                            <img src={_common.GetMobileAppAnnouncement('mobileapptwo')} style={{ width: '-webkit-fill-available' }} alt="MobileAppAnnouncement2"></img>
                            <img src={_common.GetMobileAppAnnouncement('mobileappthree')} style={{ width: '-webkit-fill-available' }} alt="MobileAppAnnouncement3"></img>
                            <img src={_common.GetMobileAppAnnouncement('mobileappfour')} style={{ width: '-webkit-fill-available' }} alt="MobileAppAnnouncement4"></img>

                            <div className="row" style={{ justifyContent: 'center' }}>
                                <a className="button" role="button" href="https://play.google.com/store/apps/details?id=com.advancity.alms">
                                    <img src={_common.GetMobileAppAnnouncement('footerplaystore')} style={{ margin: '5px', width: '100px', height: ' 30px!important' }} alt="playstore" width="100" height="30" />
                                </a>
                                <a className="button" role="button" href="https://apps.apple.com/tr/app/kampus365/id1606171662?l=tr">
                                    <img src={_common.GetMobileAppAnnouncement('footerappstore')} style={{ margin: '5px', width: '100px', height: ' 30px!important' }} alt="playstore" width="100" height="30" />
                                </a>
                            </div>
                            {/* <div className="mini-btn mt-4 ml-auto">
                                                
                                            </div> */}
                        </div>
                        <div className="mt-4 mb-4 border-bottom" />
                        {/* Announcement enrollments */}
                        <div className="mini-btn mt-4 ml-auto">
                            {/* tslint:disable-next-line */}
                            <button onClick={() => this.props.onClickChangeAnnouncement(false)} type="button" style={{ float: 'right' }} className="btn btn-green mt-md-0 mt-2 mb-md-0 mb-2">
                                {T.t('r_continue')}
                                <i className="material-icons small ml-2">arrow_forward</i>
                            </button>
                            <button onClick={() => this.props.onClickChangeAnnouncement(true)} type="button" style={{ float: 'right', marginRight: '5px' }} className="btn btn-green mt-md-0 mt-2 mb-md-0 mb-2">
                                {T.t('r_dont_show_again')}
                                <i className="material-icons small ml-2">arrow_forward</i>
                            </button>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ILoginAnnouncementModalProp): ILoginAnnouncementModalProp => {
    if (!state) {
        return ownProps;
    }

    const newProps: ILoginAnnouncementModalProp = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType,
        selectedAnnouncement: state.announcement.selectedAnnouncement,
        organizationId: state.login.login.organizationId,
        selectedAnnouncementIsLoaded: state.announcement.selectedAnnouncementIsLoaded,
        userPreferences: state.profile.userPreferences
    });

    return newProps;
};

const MobileAnnouncementModal = connect(mapStateToProps)(CMobileAnnouncementModal);

export default MobileAnnouncementModal;
